import * as React from "react";
import ZohoTab from './ZohoTab';
import Container from '@mui/material/Container';
 
const Zoho = (props) => { 

  return (
    <div className="App">
      <Container maxWidth={false}>
        <ZohoTab />
      </Container>
    </div>
  );
}
export default Zoho;
